module.exports = __webpack_public_path__ + "img/9788937834400.50215fb9.jpg";